var map = {
	"./br/PT/S1/gm7.png": 71026,
	"./in/EN/S1/gm7.png": 11145,
	"./ph/EN/S1/gm7.png": 87250,
	"./vn/VI/S1/gm7.png": 95878
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51515;